import { parseScenePlan } from '@toolproof-core/lib/_pure/scene-plan';

import naturalAdd from '@/adapters/primitive/_data/episodes/_@sub_natural/natural-add.json' with { type: 'json' };
import { primitiveScenePlanSource } from './_data/scenePlanAuthoring';
import { primitiveScenePlanDialect } from './_data/scenePlanDialect';
import type { EpisodeAuditionSupport } from '@/_contract/episodeSupport';
import type { ScenePlanAuditionPreview } from '@/_contract/scenePlanAudition';
import type { PrimitiveEpisode } from '@/adapters/primitive/_contract/episode';
import type { PrimitivePlanEffect } from './_contract/scenePlan';

const auditions = new Map<string, ScenePlanAuditionPreview<PrimitivePlanEffect>>();
export const auditionEpisodeHandle = (id: string) => `EPISODE-audition-${id}`;

export function registerScenePlanAudition(preview: ScenePlanAuditionPreview) {
    const { audition } = preview;
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(audition.id)
        || audition.schemaVersion !== 1) throw new Error('Invalid audition identity.');
    const plan = parseScenePlan<PrimitivePlanEffect>(audition.plan, primitiveScenePlanDialect);
    auditions.set(auditionEpisodeHandle(audition.id), { ...preview, audition: { ...audition, plan } });
}

export function resolveScenePlanAudition(handle: string) {
    return auditions.get(handle);
}

export function resolveAuditionEpisode(handle: string): PrimitiveEpisode | undefined {
    const preview = auditions.get(handle);
    if (!preview) return undefined;
    const { audition } = preview;
    if (audition.source.episodeHandle !== naturalAdd.handle) throw new Error('Unsupported audition source episode.');
    return { handle, schemaVersion: 2, title: `${naturalAdd.title} [audition]`, scenes: [
        { sceneKind: 'trace', id: audition.source.sceneId, title: audition.plan.title,
            trace: audition.plan.trace, beats: audition.plan.beats },
    ] };
}

export const primitiveEpisodeAuditions: EpisodeAuditionSupport = {
    apiUrl: '/api/scene-plan-auditions',
    source: { handle: primitiveScenePlanSource.episodeHandle, title: naturalAdd.title,
        sceneId: primitiveScenePlanSource.sceneId, description: 'NaturalAdd 2 + 3.' },
    isHandle: handle => handle.startsWith('EPISODE-audition-'),
    episodeHandle: auditionEpisodeHandle,
    episodeHandles: () => [...auditions.keys()],
    resolveEpisode: resolveAuditionEpisode,
    register: preview => {
        if (preview.audition.source.episodeHandle !== primitiveScenePlanSource.episodeHandle
            || preview.audition.source.sceneId !== primitiveScenePlanSource.sceneId) throw new Error('Unsupported audition source scene.');
        registerScenePlanAudition(preview);
    },
};
